import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFleetinfoPage } from './cabsand-fleetinfo';

@NgModule({
  declarations: [
    CabsandFleetinfoPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFleetinfoPage),
  ],
})
export class CabsandFleetinfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fleetinfo/cabsand-fleetinfo.module.ts